import type { IconName } from '@gftg/ui';

export interface Tab {
  to: string;
  label: string;
  icon: IconName;
  /** Screens that belong to this tab without being under its path. */
  covers?: string[];
}

/**
 * The five destinations the design names, in its order. They are here rather than in the tab bar
 * because a laptop gets the same five in a header across the top, and a list of tabs that lived in
 * one of the two bars would drift from the other.
 */
export const TABS: Tab[] = [
  { to: '/', label: 'Home', icon: 'home' },
  // The venue mockup marks this tab, so the screens about the conference itself rather than about
  // this attendee belong to it: the venue, and the presenters by the same reading.
  { to: '/program', label: 'Agenda', icon: 'agenda', covers: ['/venue', '/speakers'] },
  { to: '/schedule', label: 'Schedule', icon: 'star' },
  // The design marks this tab while the directory is open: both screens are about people, and
  // the directory is reached from the home screen, so otherwise no tab would be lit at all.
  { to: '/matches', label: 'Matches', icon: 'matches', covers: ['/directory'] },
  { to: '/account', label: 'Profile', icon: 'profile' },
];

export function isTabActive(tab: Tab, pathname: string): boolean {
  if (tab.to === '/') {
    return pathname === '/';
  }

  return [tab.to, ...(tab.covers ?? [])].some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}
